import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type ThemeMode = 'light' | 'dark';

interface ThemeState {
   mode: ThemeMode;
   setMode: (mode: ThemeMode) => void;
   toggle: () => void;
}

const useThemeStore = create<ThemeState>()(
   persist(
      (set, get) => ({
         mode: 'light',
         setMode: (mode) => set({ mode }),
         toggle: () => set({ mode: get().mode === 'light' ? 'dark' : 'light' }),
      }),
      { name: 'smartfi-theme', storage: createJSONStorage(() => localStorage) }
   )
);

export default useThemeStore;
